import { Redirect } from "@reach/router";
import useAuth from "hooks/useAuth";

export default function Home(props: ReachPathProps) {
  const { user } = useAuth();
  if (!user) return <Redirect from="/" to="/login" noThrow />;
  return <Redirect from="/" to="dsp/dashboard" noThrow />;
}
